import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import { MenuCustomizationDTO } from '@/service-proxies/app-v2/system.service-proxies'

@Component
export default class EditForm extends Vue {
  @Prop({ default: () => null }) record: Partial<MenuCustomizationDTO>
  @Ref() dForm: any

  get schema() {
    return {
      properties: {
        desc: {
          default: this.record?.menuDescription,
          title: this.$t('page_menu_desc'),
          readOnly: true,
        },
        source: {
          default: this.record?.menuSource,
          title: this.$t('page_menu_icon'),
          ui: {
            widget: 'icon-select',
          },
        },
        sort: {
          default: this.record?.menuSort,
          title: this.$t('page_menu_sort'),
          ui: {
            widget: 'input-number',
            min: 0,
            max: 100,
          },
        },
      },
      required: ['sort'],
    }
  }

  render() {
    return <d-form schema={this.schema} ref="dForm" />
  }
}
